/**
 * Created by yangrui on 2021/4/14.
 */
'use strict';
import {Validated, Length, NotNull} from "./commonRules";
import {CQyzzjgdmRule} from './rules';

function _valueExist(value) {
    if (typeof value == 'string' || value.constructor == String) {
        // 如果是字符串类型数据去除两侧空格再校验
        value = value.trim();
    }
    return value && value !== "undefined";
}


/** 申请开票 start */

//发票类型
const Rule_nFplx = new NotNull('string', '请输入发票类型');

//基本信息
//1. 保单号
const Rule_cDbh = new NotNull('string', '请输入保单号');
//2. 抬头类型
const Rule_nTtlx = new NotNull('string', '请选择抬头类型');
//3. 抬头名称
const Rule_cTtmc = new NotNull('string', '请选择抬头名称');
//4. 证件(照)类型
const Rule_nZzlx = new NotNull('string', '请选择证件(照)类型');

//5. 证件(照)号码
const Rule_cZzhm = CQyzzjgdmRule;

//6. 纳税人名称
function Rule_cNsrmc(required) {
    return new Validated("string", value => {
        if (!_valueExist(value)) {
            return "请输入纳税人名称";
        }
        if (value.length > 100) {
            return "纳税人名称最大限制为100位";
        }
    }, required);
}

//7. 纳税人识别号
function Rule_cNsrsbh(required) {
    return new Validated("string", value => {
        if (!_valueExist(value)) {
            return "请输入纳税人识别号";
        }
        if (value.length > 100) {
            return "纳税人识别号最大限制为100位";
        }
    }, required);
}

//8. 电话
function Rule_cDh(required) {
    return new Validated("string", value => {
        if (!_valueExist(value)) {
            return "请输入电话";
        }
        if (value.length > 20) {
            return "电话最大限制为20位";
        }
    }, required);
}

//9. 开户银行名称
function Rule_cKhyhmc(required) {
    return new Validated("string", value => {
        if (!_valueExist(value)) {
            return "请输入开户银行名称";
        }
        if (value.length > 100) {
            return "开户银行名称最大限制为100位";
        }
    }, required);
}

//8. 开户银行账号
function Rule_cKhyhzh(required) {
    return new Validated("string", value => {
        if (!_valueExist(value)) {
            return "请输入开户银行账号";
        }
        if (value.length > 50) {
            return "开户银行账号最大限制为50位";
        }
    }, required);
}

//11. 地址
function Rule_cDz(required) {
    return new Validated("string", value => {
        if (!_valueExist(value)) {
            return "请输入地址";
        }
        if (value.length > 100) {
            return "地址最大限制为100位";
        }
    }, required);
}

//寄送信息
//1. 联系人
function Rule_cLxr(required) {
    return new Validated("string", value => {
        if (!_valueExist(value)) {
            return "请输入联系人";
        }
        if (value.length > 100) {
            return "联系人最大限制为100位";
        }
    }, required);
}

//2. 联系人电话
function Rule_cLxrdh(required) {
    return new Validated("string", value => {
        if (!_valueExist(value)) {
            return "请输入联系人电话";
        }
        if (value.length > 20) {
            return "联系人电话最大限制为20位";
        }
    }, required);
}

//3.邮箱
function Rule_cYx(required) {
    return new Validated("string", value => {
        if (value.length > 100) {
            return "邮箱最大限制为100位";
        }
    }, required);
}

//4. 发票寄送地址
function Rule_nFsdz(required) {
    return new Validated("string", value => {
        if (!_valueExist(value)) {
            return "请输入发票寄送地址";
        }
        if (value.length > 100) {
            return "发票寄送地址最大限制为100位";
        }
    }, required);
}

/** 申请开票 end */


/** 申请退保 start */
//1. 担保金额 Rule_nDbje
const Rule_nDbje = new NotNull('string', '请输入担保金额');

//2. 保单号 Rule_cDbh

//3. 保全法官联系电话
function Rule_cFglxdh(required) {
    return new Validated("string", value => {
        if (!_valueExist(value)) {
            return "请输入保全法官联系电话";
        }
        if (value.length > 20) {
            return "保全法官联系电话最大限制为20位";
        }
    }, required);
}
//4. 创建申请日期
const Rule_dtCreatetime = new NotNull('string', '请输入创建申请日期');
//5. 退保类型
const Rule_nTblx = new NotNull('string', '请输入退保类型');
//6. 类型描述
function Rule_cLxms(required) {
    return new Validated("string", value => {
        if (!_valueExist(value)) {
            return "请输入类型描述";
        }
        if (value.length > 200) {
            return "类型描述最大限制为200位";
        }
    }, required);
}

/** 申请退保 end */

export {
    /** 申请开票 start */
    Rule_nFplx, // 发票类型
    Rule_cDbh,  // 保单号
    Rule_nTtlx, //抬头类型
    Rule_cTtmc, // 抬头名称
    Rule_nZzlx, // 证件(照)类型
    Rule_cZzhm, // 证件(照)号码
    Rule_cNsrmc, // 纳锐人名称
    Rule_cNsrsbh, // 纳税人识别号
    Rule_cDh, // 电话
    Rule_cKhyhmc, // 开户银行名称
    Rule_cKhyhzh, // 开户银行账号
    Rule_cDz,  //地址
    Rule_cLxr, //联系人
    Rule_cLxrdh, // 联系人电话
    Rule_cYx, // 邮箱
    Rule_nFsdz, // 发票寄送地址
    /** 申请开票 end */

    /** 申请退保 start */
    Rule_nDbje,//1. 担保金额
    Rule_cFglxdh,//2. 保全法官联系电话
    Rule_dtCreatetime,//3. 创建申请日期
    Rule_nTblx,//4. 退保类型
    Rule_cLxms//5. 类型描述
    /** 申请退保 end */
}
